import { fetchEmployees } from './employees';
import { fetchOwnerSubstores } from './substore';
import { getCurrentSubscription, getActivePlans } from './subscription';

// Fetch and cache employee, substore, and subscription data after login
// Serialized to prevent SQLite database lock errors
export async function cacheAfterLogin() {
  try {
    console.log('cacheAfterLogin: Starting serialized data fetch...');
    
    // Fetch employees first
    console.log('cacheAfterLogin: Fetching employees...');
    const employees = await fetchEmployees();
    localStorage.setItem('employees', JSON.stringify(employees));
    console.log('cacheAfterLogin: Employees fetched and cached');
    
    // Fetch substores second
    console.log('cacheAfterLogin: Fetching substores...');
    const substoresResponse = await fetchOwnerSubstores();
    const substores = substoresResponse.substores || [];
    localStorage.setItem('substores', JSON.stringify(substores));
    console.log('cacheAfterLogin: Substores fetched and cached');
    
    // Fetch subscription data third
    console.log('cacheAfterLogin: Fetching subscription data...');
    let subscriptionData = null;
    try {
      subscriptionData = await getCurrentSubscription();
      localStorage.setItem('subscription', JSON.stringify(subscriptionData));
      console.log('cacheAfterLogin: Subscription data fetched and cached');
    } catch (err) {
      console.warn('cacheAfterLogin: Failed to fetch subscription:', err);
    }
    
    // Fetch plans last
    console.log('cacheAfterLogin: Fetching plans...');
    let plansData = [];
    try {
      plansData = await getActivePlans();
      localStorage.setItem('plans', JSON.stringify(plansData));
      console.log('cacheAfterLogin: Plans fetched and cached');
    } catch (err) {
      console.warn('cacheAfterLogin: Failed to fetch plans:', err);
    }

    console.log('cacheAfterLogin: All data fetched successfully');
    return { employees, substores, subscription: subscriptionData, plans: plansData };
  } catch (err) {
    console.error('cacheAfterLogin: Error in serialized data fetch:', err);
    
    // Check if error is due to HTML response instead of JSON
    if (err.message && err.message.includes('Unexpected token')) {
      console.error('cacheAfterLogin: Received HTML response instead of JSON. Check API endpoints and server status.');
    }
    
    return { employees: [], substores: [], subscription: null, plans: [] };
  }
}

// Automated cache refresh every 5 minutes
export function startAutoCacheRefresh(intervalMs = 300000) {
  // 5 minutes
  cacheAfterLogin(); // Initial fetch
  setInterval(cacheAfterLogin, intervalMs);
}
